// Emoji flag from an ISO alpha-2 code (countries.iso_code). A country without
// a code gets a white flag; a quest with no country at all gets a globe.
export const flagOf = (isoCode, hasCountry = true) => {
  if (!hasCountry) return '🌐';
  if (!isoCode || !/^[A-Za-z]{2}$/.test(isoCode)) return '🏳️';
  return String.fromCodePoint(...[...isoCode.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
};
